import { isMobile } from 'react-device-detect';
import queryString from 'query-string';
import * as clientErrTypes from 'config/clientErrorTypes';
import {
    FEVER_LOGIN_API_ENDPOINT,
    CLIENT_API_FEVER_HOST,
    IS_IFRAME_MODE,
    IS_UGC_FLOW
} from 'config/envVariable';
import {
    loginTypesForLiff,
    loginTypeMappingPointRoutesParam,
    loginTypes,
    loginTypesForApi
} from 'config/loginTypes';
import * as postMsgEvent from 'config/postMsgEvent';
import { getQsOfParentUrl } from 'client/utils/queryString';
import { getLogInInfoAPI } from 'client/utils/tokenManager';
import { setLocalStorage, getLoginSeverKeyPutIntoLocalParams } from 'utils/localStorage';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';

export function getRedirectUrlFromLoginServerToPromoOrUgc({ promoUUID, promoId } = {}) {
    const { parentUrl, ...restQs } = queryString.parse(window.location.search);
    const qsOfParentUrl = getQsOfParentUrl(parentUrl);
    const qs = queryString.stringify({
        ...qsOfParentUrl,
        ...restQs,
        ...(IS_UGC_FLOW ? { ugc_path: window.location.pathname } : {})
    });
    const pathHandleLoginRedirectBack = `${
        window.location.origin
    }/promotions/${promoUUID}/${promoId}/login${qs ? `?${qs}` : ''}${window.location.hash}`;
    return pathHandleLoginRedirectBack;
}

export function getRedirectUrlFromLoginServerToSponsorReward({
    sponsorUUID,
    loginType,
    appendQsObj = {}
} = {}) {
    const query = { ...queryString.parse(window.location.search), ...appendQsObj };
    const qs = queryString.stringify(query);
    return `${window.location.origin}/promotions/rewards/${sponsorUUID}/${loginType}${
        qs ? `?${qs}` : ''
    }${window.location.hash}`;
}

// 返回點數紀錄頁 LoginHandle 頁
export function getRedirectToPointLoginHandlerUrl({
    sponsorUUID,
    pointPoolUUID,
    loginType,
    appendQsObj = {}
} = {}) {
    const query = { ...queryString.parse(window.location.search), ...appendQsObj };
    const qs = queryString.stringify(query);
    return `${
        window.location.origin
    }/point/${sponsorUUID}/${pointPoolUUID}/${loginType}/loginHandle${qs ? `?${qs}` : ''}${
        window.location.hash
    }`;
}

// 返回點數紀錄頁面
export function getRedirectUrlFromLoginServerToPointRecord({
    sponsorUUID,
    pointPoolUUID,
    loginType,
    appendQsObj = {}
} = {}) {
    const query = { ...queryString.parse(window.location.search), ...appendQsObj };
    const qs = queryString.stringify(query);
    return `${window.location.origin}/point/${sponsorUUID}/${pointPoolUUID}/${loginType}${
        qs ? `?${qs}` : ''
    }${window.location.hash}`;
}

export function getFeverLoginUrl({ loginType, redirectUrl, sponsorUUID, appendQsObj = {} } = {}) {
    const loginUrl = `${FEVER_LOGIN_API_ENDPOINT}/auth/client/${loginType}`;
    const urlParam = {
        redirect_uri: redirectUrl,
        'fever-host': appendQsObj?.['fever-host']
            ? appendQsObj?.['fever-host']
            : CLIENT_API_FEVER_HOST,
        sponsor_uuid: sponsorUUID
    };
    const qsString = queryString.stringify({ ...appendQsObj, ...urlParam });

    return `${loginUrl}?${qsString}`;
}

export function getLiffUrl({
    liffId,
    sponsorUUID,
    loginType = loginTypesForLiff.LIFF_TOKEN,
    redirectPath,
    appendQsObj = {}
} = {}) {
    let liffUrlQueryObj = {
        ...appendQsObj,
        login_type: loginType,
        liff_id: liffId,
        sponsor_uuid: sponsorUUID
    };
    const liffUrlQueryString = queryString.stringify(liffUrlQueryObj);

    return `https://liff.line.me/${liffId}${redirectPath}?${liffUrlQueryString}`;
}

export function getEnterpriseLoginUrl({
    partner = {},
    sponsor = {},
    promoId,
    redirectUrl,
    appendQsObj = {}
} = {}) {
    const { uuid: sponsorUUID, enterpriseShopDomain, enterpriseShopId } = sponsor;
    // [NFV-557] 91 登入串接用，讓他能在 promo 用企業登入
    const isEnterpriseCustomLogin = Boolean(enterpriseShopDomain) && Boolean(enterpriseShopId);
    if (isEnterpriseCustomLogin) {
        return getEnterpriseLoginUrlCustom(enterpriseShopDomain, enterpriseShopId, promoId);
    } else {
        return getFeverLoginUrl({
            loginType: 'enterprise',
            sponsorUUID,
            redirectUrl,
            appendQsObj: {
                ...appendQsObj,
                ...getEnterpriseLoginUrlAppendQuery({
                    partner,
                    sponsor,
                    promoId
                })
            }
        });
    }
}
function getEnterpriseLoginUrlCustom(enterpriseShopDomain, enterpriseShopId, promoId) {
    const loginUrl = `https://${enterpriseShopDomain}/v2/FSevent/${enterpriseShopId}/${promoId}`;
    return loginUrl;
}
function getEnterpriseLoginUrlAppendQuery({ partner = {}, sponsor = {}, promoId }) {
    const {
        enableEnterpriseLoginFvQuery,
        enterpriseLoginAppId: partnerEnterpriseLoginAppId,
        enterpriseLiteLoginAppId: partnerEnterpriseLiteLoginAppId,
        enterpriseCustomizedLoginType: partnerEnterpriseCustomizedLoginType,
        enterpriseLoginSubType: partnerEnterpriseLoginSubType
    } = partner;
    const {
        id: sponsorId,
        enterpriseLoginAppId: sponsorEnterpriseLoginAppId,
        enterpriseLiteLoginAppId: sponsorEnterpriseLiteLoginAppId,
        enterpriseCustomizedLoginType: sponsorEnterpriseCustomizedLoginType,
        enterpriseLoginSubType: sponsorEnterpriseLoginSubType
    } = sponsor;

    let obj = {};
    if (Boolean(enableEnterpriseLoginFvQuery)) {
        obj.fv_sponsor_id = sponsorId;
        obj.fv_promo_id = promoId;
    }
    // [#86enfp1m8] 客製登入
    // [#86eq80qa4] 提供以 Cookieless 方式完成 oAuth 驗證
    // 有設定 App Id 代表有串其他平台登入
    if (sponsorEnterpriseLoginAppId || partnerEnterpriseLoginAppId) {
        // handle sponsor 有設定 subtype，但是沒有給 sponsor 對應需要的 Lite Login AppId
        if (sponsorEnterpriseLoginSubType === 'lite' && !sponsorEnterpriseLiteLoginAppId) {
            return obj;
        }
        // handle partner 有設定 subtype，但是沒有給 sponsor 對應需要的 Lite Login AppId
        if (partnerEnterpriseLoginSubType === 'lite' && !partnerEnterpriseLiteLoginAppId) {
            return obj;
        }

        // sponsor / partner setting 有設定 enterpriseLoginSubType 就會給subtype參數到客製化連結 (Ex: cookieless: 後端手動塞, lite: admin-tool 可以設定)
        if (partnerEnterpriseLoginSubType) {
            obj.subtype = partnerEnterpriseLoginSubType;
        }

        if (sponsorEnterpriseLoginSubType) {
            obj.subtype = sponsorEnterpriseLoginSubType;
        }

        // Ex: sponsorEnterpriseCustomizedLoginType = skm, 91App...etc
        if (sponsorEnterpriseCustomizedLoginType || partnerEnterpriseCustomizedLoginType) {
            obj.subtype = 'custom';
        }
    } else {
        // 如果沒有串其他平台登入，但他有提供 enterpriseLiteLoginAppId，那就是可以走簡易登入
        if (sponsorEnterpriseLiteLoginAppId || partnerEnterpriseLiteLoginAppId) {
            obj.subtype = 'lite';
        }
    }
    return obj;
}

const isInMitch = window.location.host === 'events.mitch.tw';
export function getLoginLinkClickAction(bindRef, url) {
    if (isMobile) {
        if (IS_IFRAME_MODE) {
            return isInMitch
                ? {
                      onClick: event => {
                          event.preventDefault();
                          setLocalStorage(getLoginSeverKeyPutIntoLocalParams());
                          window.parent.postMessage(
                              {
                                  event: postMsgEvent.PARENT_REDIRECT,
                                  payload: { url }
                              },
                              '*'
                          );
                      }
                  }
                : {
                      target: '_blank',
                      href: url,
                      onClick: () => {
                          setLocalStorage(getLoginSeverKeyPutIntoLocalParams());
                      }
                  };
        } else {
            return {
                target: '_self',
                href: url,
                onClick: () => {
                    setLocalStorage(getLoginSeverKeyPutIntoLocalParams());
                }
            };
        }
    } else {
        return {
            onClick: event => {
                event.preventDefault();
                bindRef.current = openWindow(url, { name: 'login' });
                setLocalStorage(getLoginSeverKeyPutIntoLocalParams());
            }
        };
    }
}

export function openWindow(url, { name = '', width = 600, height = 700 } = {}) {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    return window.open(
        url,
        name,
        `menubar=0,resizable=0,width=${width},height=${height}, top=${top}, left=${left}`
    );
}

export const getLoginUserInfo = async loginMethod => {
    if (loginMethod === loginTypes.ANONYMOUSLOGIN) {
        return { loginType: loginTypesForApi.ANONYMOUS };
    }
    if (loginMethod === loginTypes.INSTAGRAM) {
        return { loginType: loginTypesForApi.INSTAGRAM };
    }
    const [loginType] = loginTypeMappingPointRoutesParam[loginMethod] || [null];
    const resp = await getLogInInfoAPI({ loginType });

    if (resp[loginType] && typeof resp[loginType] === 'object') {
        const { user } = Object.values(resp[loginType])[0];
        return { ...user, loginType };
    } else {
        const maskedSensitiveResp = await recursiveMask(resp, {
            app_id: { visibleStart: 4, visibleEnd: 4 },
            code: { visibleStart: 0, visibleEnd: 0 },
            email: { visibleStart: 2, visibleEnd: 10 },
            fullname: { visibleStart: 1, visibleEnd: 0 },
            access_token: { visibleStart: 4, visibleEnd: 4 }
        });
        throw generateApiErrObj(maskedSensitiveResp, clientErrTypes.LOGIN_USER_INFO_FAILED, {
            loginType,
            loginMethod
        });
    }
};

/**
 * @description Masks a given string or value by replacing the middle portion with asterisks (`*`),
 *              while keeping a specified number of characters visible at the start and end.
 * @param {string} value - The string to be masked.
 * @param {number} [visibleCharsStart=0] - The number of characters to keep visible at the start of the string.
 * @param {number} [visibleCharsEnd=0] - The number of characters to keep visible at the end of the string.
 * @returns {string} - The masked string with asterisks in the middle and visible characters at the start and end.
 *
 * @example
 * // Example 1: Masking an email address
 * const maskedEmail = maskValue('s110319022@stu.ntue.edu.tw', 2, 10);
 * // maskedEmail -> "s1********@stu.ntue.edu.tw"
 *
 * @example
 * // Example 2: Masking an access token
 * const maskedToken = maskValue('EAADTmsjG8VMBO1UCaT7ucEqixaJgiExvXyGwaUt', 4, 4);
 * // maskedToken -> "EAAD************aUt"
 */
export function maskValue(value, visibleCharsStart = 0, visibleCharsEnd = 0) {
    const totalLength = value.length;
    const maskedPortion = '*'.repeat(totalLength - visibleCharsStart - visibleCharsEnd);
    return (
        value.substring(0, visibleCharsStart) +
        maskedPortion +
        value.substring(totalLength - visibleCharsEnd)
    );
}

/**
 * @description Recursive function to traverse and mask the object.
 *              It masks specific keys based on the provided keysToMask configuration.
 * @param {Object} obj - The object to traverse and mask.
 * @param {Object} keysToMask - An object defining which keys to mask and how many characters to show.
 * @param {Object} keysToMask.key - For each key to be masked, specify the number of visible characters at the start and end.
 * @param {number} keysToMask.key.visibleStart - The number of characters to show at the start of the value.
 * @param {number} keysToMask.key.visibleEnd - The number of characters to show at the end of the value.
 * @returns {Object} - A new object with masked values.
 *
 * @example
 * const keysToMask = {
 *   "id": { visibleStart: 4, visibleEnd: 4 },
 *   "app_id": { visibleStart: 4, visibleEnd: 4 },
 *   "member_uuid": { visibleStart: 4, visibleEnd: 4 },
 *   "email": { visibleStart: 2, visibleEnd: 10 },
 *   "fullname": { visibleStart: 1, visibleEnd: 0 },
 *   "gender": { visibleStart: 0, visibleEnd: 0 },  // Completely mask gender
 *   "access_token": { visibleStart: 4, visibleEnd: 4 }
 * };
 *
 * recursiveMask(userLoginInfo, keysToMask);
 */
export async function recursiveMask(obj, keysToMask) {
    const _obj = { ...obj };

    for (let key in _obj) {
        if (typeof _obj[key] === 'object' && _obj[key] !== null) {
            // If the value is an object, call the function recursively
            _obj[key] = await recursiveMask(_obj[key], keysToMask);
        } else {
            // Apply masking for keys that are in the keysToMask argument
            if (keysToMask[key]) {
                if (typeof _obj[key] === 'string' || typeof _obj[key] === 'number') {
                    const valueStr = _obj[key].toString();
                    const { visibleStart, visibleEnd } = keysToMask[key];
                    _obj[key] = maskValue(valueStr, visibleStart, visibleEnd);
                }
            }
        }
    }
    return _obj;
}
